<template>
  <el-dialog
    :title="$t('text.manage_area_filter')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="closeDialog()"
    width="600px"
    class="manage-area"
    v-if="dialogVisible"
  >
    <div v-if="allAreaFilters.length">
      <div class="step-wrapper">
        <el-steps
          :active="activeCard"
          finish-status="success"
          simple
          class="manage-area-step"
          :class="form.areaFilter ? 'clickable-step' : ''"
        >
          <el-step
            :title="$t('text.select_an_area')"
            icon="el-icon-office-building"
            @click.native="goTab(0)"
            :class="activeCard === 0 ? 'active-step' : ''"
          ></el-step>
          <el-step
            :title="$t('text.manage_area')"
            icon="el-icon-help"
            @click.native="goTab(1)"
            :class="activeCard === 1 ? 'active-step' : ''"
          ></el-step>
        </el-steps>
      </div>
      <el-form :model="form" ref="form" :rules="rules" v-if="activeCard === 0">
        <el-form-item prop="areaFilter">
          <el-select
            v-model="form.areaFilter"
            filterable
            :placeholder="$t('text.select')"
            class="wp-100"
            @change="handleAreaFilterChange"
          >
            <el-option
              v-for="filter in allAreaFilters"
              :key="filter.WardId"
              :label="filter.Name"
              :value="filter.WardId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <el-empty :description="$t('text.no_area')">
        <el-button class="common-btn min-w-80" @click="addArea()">{{
          $t('text.new_area')
        }}</el-button>
      </el-empty>
    </div>

    <UpdateArea
      ref="updateArea"
      v-if="activeCard === 1"
      :areaFilterId="form.areaFilter"
      @deleteSuccess="deleteSuccess"
      @loadingChange="loadingChange"
    />
    <AddArea ref="addArea" />
    <div slot="footer" class="dialog-footer" v-if="allAreaFilters.length">
      <el-button
        type="text"
        class="back-btn"
        v-if="activeCard !== 0"
        @click="back()"
        ><i class="el-icon-arrow-left mr-5"></i
        >{{ $t('text.back').toUpperCase() }}</el-button
      >
      <el-button
        class="common-btn min-w-80"
        @click="submit()"
        :loading="loading"
        v-if="activeCard !== 0"
        >{{ $t('text.update').toUpperCase() }}</el-button
      >
      <el-button class="common-btn min-w-80" @click="next()" v-else>{{
        $t('text.continue').toUpperCase()
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import UpdateArea from '@/components/dashboard/UpdateArea.vue'
import AddArea from '@/components/dashboard/AddArea'
export default {
  data() {
    return {
      dialogVisible: false,
      activeCard: 0,
      loading: false,
      form: {
        areaFilter: ''
      },
      rules: {
        areaFilter: [
          {
            required: true,
            message: this.$t('text.please_select_area_filter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    allAreaFilters() {
      return this.$store.state.filter.areaFilters
    }
  },
  mounted() {
    this.buildings = this.$store.state.filter.buildings
  },
  components: {
    UpdateArea,
    AddArea
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      this.activeCard = 0
    },
    closeDialog() {
      this.form = {
        areaFilter: ''
      }
      this.activeCard = 0
      this.dialogVisible = false
    },
    goTab(index) {
      if (!this.form.areaFilter) return false
      this.activeCard = index
    },
    next() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.activeCard++
        }
      })
    },
    back() {
      this.activeCard--
    },
    submit() {
      this.$refs.updateArea.submit()
    },
    loadingChange(val) {
      this.loading = val
    },
    deleteSuccess() {
      this.back()
      this.form.areaFilter = ''
    },
    handleAreaFilterChange() {
      if (this.form.areaFilter) {
        this.activeCard++
      }
    },
    addArea() {
      this.$refs.addArea.openDialog()
    }
  }
}
</script>
